import { useEffect, useState, useRef } from 'react';
import { getInstantInkCard } from '../cardDefinitions';
import { IFrameCardProps } from '../FrameCardTemplate';

interface Props {
  translate: any;
  language: string;
  country: string;
  instantInkSubDifferentThanInactiveExists: boolean;
  isSubscriptionsLoading: boolean;
  onError: () => void;
}

export function useLoadInstantInkCard({
  translate,
  language,
  country,
  instantInkSubDifferentThanInactiveExists,
  isSubscriptionsLoading,
  onError
}: Props): { resolved: boolean; card: IFrameCardProps | null } {
  const [resolved, setResolved] = useState(false);
  const [card, setCard] = useState<IFrameCardProps | null>(null);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    if (isSubscriptionsLoading) return;

    function safeSetState<T>(setter: (value: T) => void, value: T) {
      if (isMounted.current) setter(value);
    }

    const finish = () => safeSetState(setResolved, true);

    if (!instantInkSubDifferentThanInactiveExists) {
      finish();
      return;
    }

    getInstantInkCard(translate, language, country)
      .then((result) => {
        if (result) safeSetState(setCard, result);
      })
      .catch(() => {
        safeSetState(onError, null);
      })
      .finally(finish);

    return () => {
      isMounted.current = false;
    };
  }, [
    translate,
    language,
    country,
    instantInkSubDifferentThanInactiveExists,
    isSubscriptionsLoading,
    onError
  ]);

  return { resolved, card };
}
